<template>
  <div class="LKPublicationsStorageFileBox">
    <v-row dense>
      <v-col cols="auto" class="LKPublicationsStorageFileBox__file">
        <LKPublicationsStorageFileIcon
          :filename="data.filename"
          :ext="ext"
          :name="data.name"
        />
      </v-col>

      <v-col
        class="LKPublicationsStorageFileBox__name"
      >
        <div class="d-block" v-text="data.filename" />
        <div class="LKPublicationsStorageFileBox__name__sub" v-html="fileBoxAvailableDates" />
      </v-col>

      <v-col cols="auto">
        <BTooltipButton
          :disabled="isDownloadDisabled"
          :icon="isDownloadDisabled ? 'mdi-download-off-outline' : 'mdi-download-outline'"
          :loading="isLoading"
          icon-size="24px"
          depressed
          top
          tooltip="Скачать"
          class-button="LKPublicationsStorageFileBox__button"
          @click="onDownload"
        />
      </v-col>
    </v-row>

    <div class="LKPublicationsStorageFileBox__desc">
      <!--
      <nobr>До 24.06.2020 20:30</nobr>
      <span> / </span>
      -->
      <nobr v-if="downloadedAt">
        Скачивался {{ downloadedAt }}
      </nobr>
      <nobr v-else>
        Еще не скачивался
      </nobr>
    </div>

    <div v-if="isUserTargetVisible" class="LKPublicationsStorageFileBox__desc">
      <v-tooltip v-if="data.for_user.length > 1" bottom>
        <template #activator="{ on }">
          <nobr v-on="on">
            Для: {{ data.for_user[0] }} (еще: {{ data.for_user.length - 1 }})
          </nobr>
        </template>
        <span>{{ data.for_user.join(', ') }}</span>
      </v-tooltip>
      <nobr v-else>
        Для: {{ data.for_user[0] }}
      </nobr>
    </div>
  </div>
</template>

<script>
import { download } from '@/helpers/downloadBlob'
import BTooltipButton from '@/components/common/BTooltipButton.vue'
import LKPublicationsStorageFileIcon from './LKPublicationsStorageFileIcon.vue'
import { dateFormatter } from '@/helpers/dateFormatter'
import { lkMapper } from '@/store/modules/lk'
import { StorageTypes } from '@/typings/api/Publication'


const createFileUrl = (
  publicationId,
  storageId,
  storageFileId,
) => `/lk/api/v2/publications/${publicationId}/storages/${storageId}/files/${storageFileId}/download`

export default {
  name: 'LKPublicationsStorageFileBox',
  components: {
    BTooltipButton,
    LKPublicationsStorageFileIcon,
  },
  props: {
    publicationId: {
      type: Number,
      required: true,
    },
    storage: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    storageIndividual: Boolean,
  },
  data: () => ({
    isLoading: false,
    downloaded_at: null,
  }),
  computed: {
    ...lkMapper.mapGetters(['profile']),
    ext() {
      const arr = this.data.name.split('.')
      const ext = arr.length > 1 ? arr[arr.length - 1] : null
      return ext
    },
    filename() {
      const { ext } = this
      const { filename } = this.data
      return ext ? `${filename}.${ext}` : filename
    },
    fileBoxAvailableDates() {
      const { data, storage } = this
      if (storage.type === StorageTypes.individual) {
        const { start_at, end_at } = data
        const arr = []
        if (start_at) {
          arr.push(`Доступен для скачивания с <b>${dateFormatter(start_at)}</b>`)
          if (end_at) {
            arr.push(`по <b>${dateFormatter(end_at)}</b>`)
          }
        }
        return arr.join(' ')
      }
      return ''
    },
    downloadedAt() {
      return dateFormatter(this.downloaded_at || this.data.downloaded_at, 'D MMMM YYYY HH:mm')
    },
    isDownloadAvailable() {
      const { data /* storage, profile */ } = this

      return !data.disabled

      /* if (data.disabled || storage.disabled) {
        return false
      }

      const isStartDateBeforeToday = (!storage.start_at || isBeforeToday(storage.start_at, profile.msk_diff))
      const isEndDateAfterToday = (!storage.end_at || isAfterToday(storage.end_at, profile.msk_diff))

      if (storage.type === StorageTypes.individual) {
        const isStartDatesBeforeToday = (!data.start_at || isBeforeToday(data.start_at, profile.msk_diff))
            && isStartDateBeforeToday
        const isEndDatesAfterToday = (!data.end_at || isAfterToday(data.end_at, profile.msk_diff))
            && isEndDateAfterToday

        return isStartDatesBeforeToday && isEndDatesAfterToday
      }
      return isStartDateBeforeToday && isEndDateAfterToday */
    },
    isDownloadDisabled() {
      return !this.isDownloadAvailable
    },
    href() {
      return createFileUrl(
        this.publicationId,
        this.storage.id,
        this.data.id,
      )
    },
    isUserTargetVisible() {
      const { data, storage, profile } = this
      return (profile.is_superuser || data.disabled)
          && storage.type === StorageTypes.individual && data.for_user?.length > 0
    },
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
    async onDownload() {
      this.isLoading = true

      try {
        await download(this.href, this.filename)
        this.isLoading = false
        this.downloaded_at = Date.now()
      } catch (e) {
        this.$notice.errors(e)
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsStorageFileBox {
  padding: 12px;
  border: 1px solid $webflow-color-blue-light;
  border-radius: 2px;

  &__header {
    display: flex;
    align-items: center;
  }

  &__name {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.25;
    word-break: break-word;

    &::after {
      position: absolute;
      right: 0;
      display: block;
      float: right;
      width: 1px;
      height: 100%;
      margin-right: 4px;
      content: "";
      background-color: $webflow-color-blue-light;
    }

    &__sub {
      font-size: 10px;
      font-weight: 300;

      b {
        font-weight: 600;
      }
    }
  }

  &__desc {
    padding: 6px 9px;
    margin-top: 10px;
    font-size: 10px;
    line-height: 1.25;
    background-color: $webflow-color-blue-light;
    border-radius: 2px;
  }

  &__button {
    color: $webflow-color-black !important;
  }
}
</style>
